import { render, staticRenderFns } from "./Fusion.vue?vue&type=template&id=bd659a86&scoped=true"
import script from "./Fusion.vue?vue&type=script&lang=js"
export * from "./Fusion.vue?vue&type=script&lang=js"
import style0 from "./Fusion.vue?vue&type=style&index=0&id=bd659a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd659a86",
  null
  
)

export default component.exports